import React from 'react';
import { ChartLine } from '@p81-common/ui';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { options } from './config';
import { colorsNew } from '../helpers/config';
import { featuresFormater } from 'utils/featuresFormater';

import '../helpers/fix.css';

const LineFA = ({ chartData = [], show = false }) => {
  const { t } = useTranslation(['activity']);

  const chartConfig = [];
  let pointsVisible = false;

  if (chartData.length > 0 && show) {
    // get feature ids (except the 'date' field)
    const featureIds = Object.keys(chartData[0]).slice(1);
    featureIds.forEach((featureId, i) => {
      chartConfig.push({
        name: featuresFormater(featureId, t),
        id: featureId,
        show: true,
        color: colorsNew[i]
      });
    });

    // check for non-zero values
    for (let i = 0; i < chartData.length; i++) {
      const dateData = chartData[i];
      const nonZeroValues = featureIds.filter(item => !!dateData[item]);
      if (nonZeroValues && nonZeroValues.length) {
        pointsVisible = true;
        break;
      }
    }
  }

  // hide points if chart is empty
  options.dots = pointsVisible;
  return <ChartLine data={chartData} chartConfig={chartConfig} {...options} />;
};

LineFA.propTypes = {
  chartData: PropTypes.arrayOf(object),
  show: PropTypes.bool
};

export default LineFA;
